import React from 'react';
import cn from 'classnames';
import { Icon } from '@cb/apricot-react-icon';
/**
 * miscellaneous Divider element
 */
export const Divider = () => React.createElement("li", { role: "separator", className: "cb-divider" });
/**
 * Select Dropdown Item - supposed to be inside the Select Dropdown component
 */
const SelectDropdownItem = ({ disabled, iconLeft = false, icon = null, label, value, divider, selected, }) => {
    return divider ? (React.createElement(Divider, null)) : (React.createElement("li", { role: "presentation", className: cn(disabled && 'cb-disabled') },
        React.createElement("a", { role: "option", href: "/#", "aria-disabled": disabled ? true : undefined, tabIndex: disabled ? -1 : undefined, "aria-selected": selected, className: cn(selected && 'cb-selected'), "data-value": value },
            iconLeft && icon && (typeof icon === 'string' ? React.createElement(Icon, { decorative: true, name: icon }) : icon),
            label,
            !iconLeft && icon && (typeof icon === 'string' ? React.createElement(Icon, { decorative: true, name: icon }) : icon))));
};
export default SelectDropdownItem;
//# sourceMappingURL=SelectDropdownItem.js.map